import React from 'react';
import ServiceDescriptionSection from '../../components/ServiceDescriptionSection';
import ServiceLegalRepresentationRationale from '../../components/ServiceLegalRepresentationRationale';
import ServiceContactUsSection from '../../components/ServiceContactUs';
import ServiceTypes from '../../components/ServiceTypes';
import serviceTypesData from '../../data/serviceTypes.json';

const TrafficDrinkDriving = () => {
  return (
    <div className='servicePage'>
      <div className='servicePageContent'>
        <div className="header">Traffic & Drink Driving Offences</div>
        <div className="body">
          <ServiceDescriptionSection
            content="Traffic and drink driving offences are among the most common legal issues people face in Victoria. The state enforces strict laws and penalties to ensure the safety of all road users. Offences range from minor infringements, such as speeding, to more serious crimes like drink driving and dangerous driving that can result in severe penalties, including fines, loss of licence, and even imprisonment."
          />
          <ServiceTypes
            header="Traffic Offences in Victoria"
            preamble="Traffic offences cover a wide spectrum of illegal driving behaviours. Some of the most common traffic offences in Victoria include:"
            typesJson={serviceTypesData["Traffic Offences"]}
          />
          <ServiceTypes
            header="Drink Driving Offences in Victoria"
            preamble="Drink driving, also known as driving under the influence (DUI), is one of the most serious traffic offences in Victoria. The law is strict when it comes to alcohol limits and the consequences for exceeding those limits are severe."
            typesJson={serviceTypesData["Drink Driving"]}
          />
          <ServiceDescriptionSection
            header="Penalties for Traffic and Drink Driving Offences"
            content={
              <div>
                <ul>
                  <li><strong>Fines:</strong> Ranging from a few hundred to several thousand dollars, depending on the severity of the offence.</li>
                  <li><strong>Demerit Points:</strong> Accumulating too many can result in licence suspension.</li>
                  <li><strong>Licence Suspension or Cancellation:</strong> Serious offences can lead to long-term disqualification.</li>
                  <li><strong>Imprisonment:</strong> High-level offences, such as dangerous driving causing injury or death, can result in jail time.</li>
                  <li><strong>Alcohol Interlock Devices:</strong> Repeat drink drivers may need to install this device before regaining their licence.</li>
                </ul>
              </div>
            }
          />
          <ServiceDescriptionSection
            header="Repeat Drink Driving Offence"
            content="Drink driving repeat offenders face increasingly harsh penalties, including mandatory installation of an alcohol interlock device, longer licence disqualification periods, larger fines, and imprisonment."
          />
          <ServiceDescriptionSection
            header="Penalties for Traffic and Drink Driving Offences"
            content={
              <div>
                <div>The penalties for traffic and drink driving offences in Victoria vary depending on the severity of the offence, the driver’s history, and other factors. These penalties may include:</div>
                <ul>
                  <li><strong>Fines:</strong> Many traffic and drink driving offences result in fines, which can range from a few hundred dollars for minor offences to several thousand dollars for more serious violations.</li>
                  <li><strong>Demerit Points:</strong> Accumulating too many demerit points can result in a licence suspension. Drivers should be mindful of their demerit point balance.</li>
                  <li><strong>Licence Suspension or Cancellation:</strong> For serious traffic offences or drink driving, drivers can face licence suspension or cancellation. The length of the suspension depends on the severity of the offence and whether it is a first or repeat offence.</li>
                  <li><strong>Imprisonment:</strong> For the most serious offences, such as high-level drink driving or dangerous driving causing injury or death, offenders can face imprisonment.</li>
                  <li><strong>Alcohol Interlock Devices:</strong> Repeat drink drivers or high-level offenders may be required to install an alcohol interlock device in their vehicle, which prevents the car from starting if alcohol is detected on the driver’s breath.</li>
                </ul>
              </div>
            }
          />
          <ServiceDescriptionSection
            header="How Drink Driving Affects Your Licence"
            content={
              <div>
                <ul>
                  <li><strong>Licence Cancellation:</strong> Offenders may face immediate cancellation of their licence.</li>
                  <li><strong>Mandatory Alcohol Interlock:</strong> Repeat offenders or those with a high BAC may need to install an alcohol interlock device in their vehicle after regaining their licence.</li>
                  <li><strong>Drink Driver Education Programs:</strong> Many drink drivers are required to complete a Behaviour Change Program before their licence is reinstated.</li>
                  <li><strong>Impact on Insurance:</strong> A drink driving conviction can also affect your car insurance premiums or result in refusal of coverage.</li>
                </ul>
              </div>
            }
          />
          <ServiceLegalRepresentationRationale
            header="The Importance of Legal Representation"
            content="Traffic and drink driving offences can have long-lasting consequences on your driving record, career, and personal life. If you are facing charges for a traffic or drink driving offence, seeking legal representation is crucial. An experienced lawyer can help you understand your options, navigate the court process, and work to minimize the penalties you face."
          />
          <ServiceContactUsSection
            header="Contact Us for Legal Assistance"
            content="If you have been charged with a traffic or drink driving offence in Victoria, our expert legal team can provide you with professional advice and representation. We are committed to helping you achieve the best possible outcome for your case."
          />
        </div>
      </div>
    </div>
  );
};

export default TrafficDrinkDriving;